import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useCallback, useRef } from 'react';
import cx from 'classnames';
import Backdrop from '@mui/material/Backdrop';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Collapse from '@mui/material/Collapse';
import useMediaQuery from '@mui/material/useMediaQuery';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';
import { alpha, styled } from '@classify/react-core-components/styles';
import browser from '@openclassrooms/utils/browser';
const Root = styled('div')(({
  theme: {
    palette,
    spacing,
    typography,
    zIndex,
    transitions
  }
}) => ({
  '& .NavigationDropDown__backdrop': {
    backgroundColor: alpha(palette.background.secondary, 0.32)
  },
  '& .NavigationDropDown__popper': {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: zIndex.modal
  },
  '& .NavigationDropDown__dropdownRoot': {
    width: '100%',
    height: '100%',
    backgroundColor: palette.background.primary
  },
  '& .NavigationDropDown__button': {
    color: palette.text.onMain,
    fontWeight: typography.fontWeightRegular,
    textTransform: 'none',
    '&:focus': {
      outline: `${palette.brand.main} auto 1px`
    },
    '&:hover, &:active': {
      color: palette.brand.main,
      backgroundColor: 'transparent',
      outline: '0'
    }
  },
  '& .NavigationDropDown__isActive': {
    color: palette.brand.main,
    '&:focus': {
      outline: '0'
    },
    '& .NavigationDropDown__buttonIcon': {
      transform: 'rotate(-180deg)'
    }
  },
  '& .NavigationDropDown__buttonIcon': {
    transition: transitions.create('transform', {
      duration: transitions.duration.shortest
    }),
    verticalAlign: 'middle',
    margin: spacing(0, 0, 0, 0.5),
    pointerEvents: 'none',
    position: 'relative'
  }
}));
const HeaderNavigationDropDown = t0 => {
  const $ = _c(59);
  const {
    isOpen,
    link,
    anchorEl: t1,
    toggleMenu,
    name,
    menuComponent: MenuComponent
  } = t0;
  const anchorEl = t1 === undefined ? null : t1;
  const [headerHeight, setHeaderHeight] = useState(64);
  const menuParentRef = useRef(null);
  const {
    content,
    dataEvent
  } = link;
  const {
    current: parentRef
  } = anchorEl;
  const hasReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const transitionDuration = hasReducedMotion ? 0 : 200;
  let t2;
  if ($[0] !== toggleMenu) {
    t2 = () => toggleMenu(false);
    $[0] = toggleMenu;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeMenu = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const header = globalThis?.document.getElementById("header");
      if (header) {
        setHeaderHeight(header.offsetTop + header.offsetHeight);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const updateHeaderHeight = t3;
  let t4;
  if ($[3] !== isOpen || $[4] !== toggleMenu) {
    t4 = event => {
      updateHeaderHeight();
      toggleMenu(!isOpen);
      event.currentTarget.blur();
    };
    $[3] = isOpen;
    $[4] = toggleMenu;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleToggleMenu = t4;
  let t5;
  if ($[6] !== closeMenu) {
    t5 = event_0 => {
      const {
        key,
        target
      } = event_0;
      const {
        current: menuParent
      } = menuParentRef;
      if (key === "Tab" && !menuParent.contains(target)) {
        closeMenu();
      }
    };
    $[6] = closeMenu;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleUserKeyPress = t5;
  let t6;
  if ($[8] !== closeMenu || $[9] !== handleUserKeyPress || $[10] !== isOpen) {
    t6 = () => {
      if (isOpen) {
        browser.window.addEventListener("scroll", closeMenu);
        browser.window.addEventListener("keyup", handleUserKeyPress);
      }
      return () => {
        browser.window.removeEventListener("scroll", closeMenu);
        browser.window.removeEventListener("keyup", handleUserKeyPress);
      };
    };
    $[8] = closeMenu;
    $[9] = handleUserKeyPress;
    $[10] = isOpen;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== closeMenu || $[13] !== handleUserKeyPress || $[14] !== isOpen || $[15] !== parentRef) {
    t7 = [closeMenu, handleUserKeyPress, isOpen, parentRef];
    $[12] = closeMenu;
    $[13] = handleUserKeyPress;
    $[14] = isOpen;
    $[15] = parentRef;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  const t8 = isOpen ? "onClick" : false;
  const t9 = isOpen ? "onTouchEnd" : false;
  const t10 = `header-submenu-${name}`;
  let t11;
  if ($[17] !== isOpen) {
    t11 = cx("NavigationDropDown__button", {
      NavigationDropDown__isActive: isOpen
    });
    $[17] = isOpen;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = `mainHeaderSubMenuButton-${name}`;
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      color: "text.primary"
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <KeyboardArrowDown className="NavigationDropDown__buttonIcon" />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== content) {
    t15 = <Typography variant="body" component="span" sx={t13}>{content}{t14}</Typography>;
    $[21] = content;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== dataEvent || $[24] !== handleToggleMenu || $[25] !== isOpen || $[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t15) {
    t16 = <Button variant="tertiary" aria-controls={t10} aria-haspopup="true" aria-expanded={isOpen} onClick={handleToggleMenu} className={t11} data-event={dataEvent} disableRipple={true} role="button" data-testid={t12}>{t15}</Button>;
    $[23] = dataEvent;
    $[24] = handleToggleMenu;
    $[25] = isOpen;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      modifiers: [{
        name: "preventOverflow",
        "& .NavigationDropDown__options": {
          padding: 0
        }
      }]
    };
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== MenuComponent || $[33] !== closeMenu || $[34] !== isOpen || $[35] !== name || $[36] !== transitionDuration) {
    t18 = t19 => {
      const {
        TransitionProps
      } = t19;
      return <Collapse {...TransitionProps} in={isOpen} style={{
        transitionTimingFunction: "ease-in-out"
      }} timeout={transitionDuration}><Paper className="NavigationDropDown__dropdownRoot" square={true} ref={menuParentRef} data-testid={`mainHeaderSubMenu-${name}`}><MenuComponent name={name} onClick={closeMenu} /></Paper></Collapse>;
    };
    $[32] = MenuComponent;
    $[33] = closeMenu;
    $[34] = isOpen;
    $[35] = name;
    $[36] = transitionDuration;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== anchorEl.current || $[39] !== isOpen || $[40] !== t18) {
    t19 = <Popper anchorEl={anchorEl.current} container={anchorEl.current} open={isOpen} className="NavigationDropDown__popper" placement="bottom-start" disablePortal={true} keepMounted={true} transition={true} popperOptions={t17} role={undefined}>{t18}</Popper>;
    $[38] = anchorEl.current;
    $[39] = isOpen;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t16 || $[43] !== t19) {
    t20 = <Root>{t16}{t19}</Root>;
    $[42] = t16;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== closeMenu || $[46] !== t20 || $[47] !== t8 || $[48] !== t9) {
    t21 = <ClickAwayListener onClickAway={closeMenu} mouseEvent={t8} touchEvent={t9}>{t20}</ClickAwayListener>;
    $[45] = closeMenu;
    $[46] = t20;
    $[47] = t8;
    $[48] = t9;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== headerHeight) {
    t22 = {
      top: headerHeight
    };
    $[50] = headerHeight;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== isOpen || $[53] !== t22 || $[54] !== transitionDuration) {
    t23 = <Backdrop style={t22} open={isOpen} className="NavigationDropDown__backdrop" transitionDuration={transitionDuration} />;
    $[52] = isOpen;
    $[53] = t22;
    $[54] = transitionDuration;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t23) {
    t24 = <>{t21}{t23}</>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  return t24;
};
export default HeaderNavigationDropDown;